import React, { useEffect, useState } from 'react';
import cx from 'classnames';
// util
import isClientSide from 'libs/client/utils/isClientSide';
import {
  CtaEventDataType,
  trackCtaViewed,
  trackCtaClicked,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';

// types
import { CtaFieldType } from 'libs/contentful/types';

// components
import RouterLink from 'components/ui/RouterLink';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

// styles
import styles from './StickyCta.module.less';

type StickyCtaProps = {
  /* CTA details to be rendered */
  /* NOTE: cta.copy must be provided; if no cta.url, <ButtonV3 /> rendered */
  cta: CtaFieldType;
  className?: string;
  /* Additional function to be called on click after trackCtaClick */
  onClick?: () => void;
  /* Indicates whether CTA is within viewport to appropriately determine when 'CTA Viewed' event should be called */
  inView: boolean;
  /* Tracking payload for 'CTA Viewed/Clicked' events */
  trackingData: CtaEventDataType;
};

const StickyCta: React.FC<StickyCtaProps> = ({ cta, className, trackingData, inView, onClick }) => {
  const [didFire, setDidFire] = useState(false);

  useEffect(() => {
    if (inView && isClientSide() && !didFire) {
      setDidFire(true);
      trackCtaViewed(trackingData);
    }
  }, [inView, didFire, setDidFire, trackingData]);

  const handleClick = () => {
    trackCtaClicked(trackingData);
    if (onClick) onClick();
  };

  return (
    <div className={styles.outer}>
      <div className={cx(className, styles.container)}>
        {cta.url ? (
          <RouterLink href={cta.url} onClick={handleClick} zuiComponent="ButtonV3">
            {cta.copy}
          </RouterLink>
        ) : (
          <ButtonV3 onClick={handleClick}>{cta.copy}</ButtonV3>
        )}
      </div>
    </div>
  );
};

export default StickyCta;
